// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "assets/css/" + chunkId + "." + {"186":"0933c20b","198":"4bf51f3d","383":"7d2ad1e9","648":"6f3376c2","687":"7ca56d7b","774":"95478baf"}[chunkId] + ".css";
};